module.exports = __webpack_public_path__ + "static/assets/3e4a9bff21fb09fe9f5117f9b771d335.svg";